import React from 'react'
import Slider from 'rc-slider'
import classnames from 'classnames'
import styles from './InputRange.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

import { handleRender } from './TooltipSlider'

const InputRange = ({
  min,
  max,
  defaultValue,
  value,
  range = false,
  allowCross = false,
  dots = false,
  step,
  invalid = false,
  hasTooltip = false,
  startPoint,
  ...props
}) => {
  const dotStyle = {
    border: 'solid 1px var(--range-interval-border-color)',
    background: 'var(--range-interval-background-color)',
    width: '10px',
    height: '10px',
  }

  const activeDotStyle = {
    border: 'solid 1px var(--range-interval-border-color-active)',
    background: 'var(--range-interval-background-color-active)',
  }

  const activeDotStyleInvalid = {
    border: 'solid 1px var(--color-6-l2)',
    background: 'var(--color-6-l1)',
  }

  const { className, ...rest } = props;
  const childrenClassNames = classnames([
    generalStyle.general_style,
    styles.container_input_range,
    invalid && styles.invalid_input_range,
  ], className)

  return (
    <div
      className={childrenClassNames}
      {...rest}
    >
      <div className={classnames(styles.container_min_value)}>
        <span>{min}</span>
      </div>
      <div className={classnames(styles.container_bar)}>
        <div className={classnames(styles.input_range)}>
          <Slider
            min={min}
            max={max}
            defaultValue={defaultValue}
            value={value}
            range={range}
            allowCross={allowCross}
            onChange={props.onChange}
            handleRender={hasTooltip ? handleRender : null}
            startPoint={startPoint}
            dotStyle={dotStyle}
            activeDotStyle={invalid ? activeDotStyleInvalid : activeDotStyle}
            dots={dots}
            step={step}
          />
        </div>
        <div className={classnames(styles.input_range_values)}>
          {dots ? (
            <ValueList max={max} min={min} step={step} />
          ) : (
            <React.Fragment />
          )}
        </div>
      </div>
      <div className={classnames(styles.container_max_value)}>
        <span>{max}</span>
      </div>
    </div>
  )
}

const Value = ({ value, index, spacing }) => {
  return (
    <span
      style={
        index === 0
          ? { transform: 'translateX(-30%)' }
          : { left: `${spacing}%`, transform: 'translateX(-66%)' }
      }
    >
      {value}
    </span>
  )
}

const ValueList = ({ max, min, step }) => {
  const dots = parseInt((max - min) / step)
  const values = []
  let spacing = 100 / dots
  for (var i = 0; i < dots + 1; i++) {
    values.push(i === 0 ? min : min + step * i)
  }
  return (
    <React.Fragment>
      <div className={classnames([styles.input_range_values_step])}>
        {values.map((_x, j) => (
          <Value index={j} key={j} spacing={spacing * j} value={values[j]} />
        ))}
      </div>
    </React.Fragment>
  )
}

export { InputRange }
